"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1514))
 * @trackcomponent
 * @lastsynced 2023-07-10T21:44:59.568Z
 */
export const Earn = createSVGIcon(
  <>
    <path
      d="M0.856934 4.28571H19.7141V16.2857H0.856934V4.28571Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.71436 10.2857C7.71436 10.9677 7.98527 11.6218 8.46751 12.104C8.94975 12.5862 9.6038 12.8572 10.2858 12.8572C10.9678 12.8572 11.6218 12.5862 12.1041 12.104C12.5863 11.6218 12.8572 10.9677 12.8572 10.2857C12.8572 9.60374 12.5863 8.94968 12.1041 8.46745C11.6218 7.98521 10.9678 7.71429 10.2858 7.71429C9.6038 7.71429 8.94975 7.98521 8.46751 8.46745C7.98527 8.94968 7.71436 9.60374 7.71436 10.2857Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 19.7143H21.4286C21.8832 19.7143 22.3193 19.5337 22.6408 19.2122C22.9622 18.8907 23.1429 18.4547 23.1429 18V9.42859"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Earn",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
